import React, { useEffect, useRef, useState } from 'react';
import './style.less'
import { Link, NavLink, useNavigate } from 'react-router-dom';
import logo from '@/assets/logo2.png'
import useWindowScrollHeight from '@/hooks/useWindowScrollHeight';
import { AiOutlineDown } from "react-icons/ai";
import ProductDrop from './ProductDrop';
import { Animated } from 'react-animated-css';
const NavBar = () => {
  const navigate = useNavigate()
  const [showChild, setShowChild] = useState(-2)
  useEffect(() => {
    setTimeout(() => {
      setShowChild(-1)//animated会有初始动画，延迟渲染盒子
    }, 500);
  }, [])

  const getScrollHeight = useWindowScrollHeight()
  const navList = [
    {
      path: '',
      name: 'Product',
      children: <ProductDrop />
    },
    { path: '/features', name: 'Features' },
    { path: '/partner', name: 'Partners' },
    { path: '/company', name: 'Company' },
  ]
  const navEnter = (index) => {
    setShowChild(index)
  }
  const NavClick = (path,event)=>{
    console.log(path)
    if(!path){
      event.preventDefault()
    }
  }
  return (
    <div className={`nav_bar ${getScrollHeight > 0 ? 'window_scroll' : ''}`}>
      <div className="nav_warp">
        <div className='logo'>
           <Link to={'/'}>
             <img src={logo} />
           </Link>
        </div>
        <div className='nav_list'>
          {
            navList.map((val, index) => {
              return <div className='nav_item'
                onMouseLeave={() => setShowChild(-1)}
                onMouseEnter={() => navEnter(index)}
              >
                <div className="nav_item_content">
                  <NavLink onClick={(e)=>NavClick(val.path,e)} className={({ isActive }) => `${isActive ? "active" : ""}`} to={val.path}>
                    {val.name}
                  </NavLink>
                  {val.children ? <AiOutlineDown className='icon' /> : false}
                </div>
                {
                  val.children ? <Animated
                    animationInDuration={300}
                    animationIn="zoomIn"
                    animationOut="zoomOut"
                    isVisible={index === showChild}>
                    {showChild > -2 && <div className="drapBox">
                      {val.children}
                    </div>}
                  </Animated> : false
                }

              </div>
            })
          }
        </div>
      </div>

    </div>
  );
}

export default NavBar;